/* Copyright (c) 2018 Scaper */

import * as React from "react";
import { Route, RouteComponentProps, Switch, withRouter } from "react-router";
import { IApi } from "../api/api";
import { ABOUT_US_PATH, BECOME_A_SCAPER_PATH, HOMEOWNERS_PATH } from "../paths/pathIndex";
import { AboutUs } from "./aboutUs/aboutUs";
import { HomePage } from "./home/homePage";
import { Homeowner } from "./homeowner/homeowner";
import { SiteNav } from "./siteNav";

import "./site.scss";

interface IProps {
    api: IApi;
}

class SiteWithoutRouter extends React.PureComponent<IProps & RouteComponentProps<any>, {}> {
    public render() {
        return (
            <div className="scpr-Site">
                <SiteNav/>


                <Switch>
                    <Route exact path="/" render={this.renderHomePage} />
                    <Route path={ABOUT_US_PATH} render={this.renderAboutUsPage} />
                    <Route path={HOMEOWNERS_PATH} render={this.renderHomeownersPage} />
                    <Route path={BECOME_A_SCAPER_PATH} render={this.renderBecomeAScaperPage} />
                    <Route render={this.renderDefault} />
                </Switch>

                <div className="scpr-Site-grass"/>
            </div>
        );
    }

    private renderHomePage = () => {
        const { api } = this.props;
        return <HomePage api={api} />;
    };

    private renderAboutUsPage = () => {
        const { api } = this.props;
        return <AboutUs api={api} />;
    };

    private renderHomeownersPage = () => {
        const { api } = this.props;
        return <Homeowner api={api} />;
    };

    private renderBecomeAScaperPage = () => {
        return (
            <div className="container">
                <div className="section">You can become a scaper</div>
            </div>
        );
    };

    private renderDefault = () => {
        return (
            <div className="container">
                <div className="section">
                    <h2>Page not found.</h2>
                    <h5>Find more information on the home page.</h5>
                </div>
            </div>
        );
    };
}

export const Site = withRouter(SiteWithoutRouter);
